import actions from '../../constants/actionTypes';
import { EnumPage } from '../../constants/enum';
import {
  handleChangeFilters,
  handleChangeTableActivePage,
  handleChangeTablePageSize,
  handleCloseDialogGeneric,
  handleOpenDialogGeneric,
} from '../../redux/genericReducerHandler';
import { COMMON_CONST } from '../../constants/constants';

const initialState = {
  filters: {
    restaurant: {
      value: 0,
      label: '',
    },
  },
  table: {
    itemList: [],
    activePage: 1,
    pageSize: COMMON_CONST.PageSize,
  },
  dialog: {
    isOpenDialog: false,
    itemDetail: {},
  },
};

function staffReducer(state = initialState, action) {
  const { response, type } = action;
  const PAGE = EnumPage.SETTING_STAFF.id;
  switch (type) {
    case actions.OPEN_DIALOG_GENERIC: {
      return handleOpenDialogGeneric(PAGE, state, action);
    }

    case actions.CLOSE_DIALOG_GENERIC: {
      return handleCloseDialogGeneric(PAGE, state, action);
    }

    case actions.CHANGE_TABLE_ACTIVE_PAGE: {
      return handleChangeTableActivePage(PAGE, state, action);
    }

    case actions.CHANGE_TABLE_PAGE_SIZE: {
      return handleChangeTablePageSize(PAGE, state, action);
    }

    case actions.CHANGE_FILTER_GENERIC: {
      return handleChangeFilters(PAGE, state, action, initialState);
    }

    case actions.RECEIVE_LIST_STAFF: {
      const { itemList } = response;
      return {
        ...state,
        table: {
          ...state.table,
          itemList,
        },
      };
    }

    case actions.OPEN_CREATE_STAFF_MODAL: {
      const { itemDetail } = response;
      return {
        ...state,
        dialog: {
          ...state.dialog,
          isOpenDialog: true,
          itemDetail,
        },
      };
    }

    default:
      return state;
  }
}

export default staffReducer;



// WEBPACK FOOTER //
// ./foody/src/pages/Staff/reducers.js